
import { Form, Button, Checkbox, InputNumber, Modal, Row, Col, Input } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './newsletter.css';
import { getDateRule } from '../utils/antUtils';
import { createNewsletters, hideNewDialog } from './newsletterActions';
import DayOfWeekComponent from "../components/dayOfWeek";

const CheckboxGroup = Checkbox.Group;

const getDatePart = (d) => d.toISOString().slice(0, 10);

class NewsletterCreateModalComponent extends Component {

  state = {
    year: 2018,
    week: 41,
    selectedDatabases: [],
    loaded: false
  }

  componentDidUpdate() {

    if (this.state.loaded) {
      return;
    }

    const oneDay = 86400000;

    if (this.props.allDatabases.length > 0) {
      this.setState({
        loaded: true,
        selectedDatabases: [],
        year: this.props.currentYear,
        week: this.props.currentWeek,
        sendDate: getDatePart(new Date(new Date().getTime() + oneDay)),
        includeFromDate: getDatePart(new Date(new Date().getTime() -  oneDay * 5)),
      })
    }

  }

  onChangeValue(value, attr) {
    let change = {};
    change[attr] = value;
    this.setState(change);
  }

  onOk = () => {

    let { year, week, selectedDatabases, isLegalLetter, sendDate, includeFromDate } = this.state;


    if(!sendDate.match(getDateRule().pattern)){
      return alert("Ange beslutsdatum på formatet " + getDatePart(new Date()) );
    }

    if(!includeFromDate.match(getDateRule().pattern)){
      return alert("Ange inkludera nyheter från på formatet " + getDatePart(new Date()) );
    }
    
    this.props.dispatch(createNewsletters(year, week, selectedDatabases.join(''), isLegalLetter, sendDate, includeFromDate))
  }

  handleCancel = () => {
    this.setState({
      loaded: false
    });
    this.props.dispatch(hideNewDialog());
  }

  onChange = (selectedDatabases) => {
    this.setState({
      selectedDatabases
    });
  }

  onChangeLegalLetter = (value) => {
    this.setState({
      isLegalLetter : value
    });
  }

  selectAll = (dayOfWeek) => {

    var selected = this.props.allDatabases.filter(db => db.sendDayOfWeek === dayOfWeek || dayOfWeek===-1 ).map((db) => db.key);
    this.setState({
      selectedDatabases: selected
    });
    
  }
  
  render() {

    if (!this.props.showNew) {
      return null;
    }

    let leftDbs = this.props.allDatabases.filter(db => db.sendDayOfWeek === 4 ).map((db) => ({ label: db.name, value: db.key }));
    let rightDbs = this.props.allDatabases.filter(db => db.sendDayOfWeek === 5 ).map((db) => ({ label: db.name, value: db.key }));

    return (

      <Modal
        title='Skapa nyhetsbrev'
        visible={true}
        width={1200}
        maskClosable={false}
        onOk={this.onOk}
        onCancel={this.handleCancel}
        okButtonProps={{ disabled: this.state.selectedDatabases.length === 0 }}
      >
        <Row style={{ ...styles.header, marginTop: 0 }}> År/Vecka </Row>
        <Row>
          <InputNumber defaultValue={this.state.year} onChange={(e) => this.onChangeValue(e, 'year')} min={2000} max={3000} />
          <InputNumber defaultValue={this.state.week} onChange={(e) => this.onChangeValue(e, 'week')} min={1} max={53} />
        </Row>
        <Row style={styles.header}>
          Utskicksdatum (<DayOfWeekComponent date={this.state.sendDate} />)
        </Row>
        <Row>
          <Input defaultValue={this.state.sendDate} onChange={(e) => this.onChangeValue(e.target.value, 'sendDate')} />
        </Row>
        <Row style={styles.header}>
          Inkludera nyheter från (<DayOfWeekComponent date={this.state.includeFromDate} />)
        </Row>
        <Row>
          <Input defaultValue={this.state.includeFromDate} onChange={(e) => this.onChangeValue(e.target.value, 'includeFromDate')} />
        </Row>
        <Row style={styles.header}> 
          <Checkbox onChange={(e) => this.onChangeLegalLetter(e.target.checked)}>Lagbrev</Checkbox>
        </Row>

        <Row style={styles.header}> Databaser </Row>
        <Row>
          <Button onClick={() => this.selectAll(-1)}>Välj alla</Button>
        </Row>
        <Row className='dbselector'>
          <Col span={12} style={styles.dbselectorColumn}>
            <Button onClick={() => this.selectAll(4)}>Välj alla</Button>            
            <CheckboxGroup options={leftDbs} value={this.state.selectedDatabases} onChange={this.onChange} />
          </Col>
          <Col span={12} style={styles.dbselectorColumn}>
          <Button onClick={() => this.selectAll(5)}>Välj alla</Button>            
            <CheckboxGroup options={rightDbs} value={this.state.selectedDatabases} onChange={this.onChange} />
          </Col>
        </Row>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showNew: state.newsletter.showNew,
    allDatabases: state.newsletter.allDatabases,
    currentYear: state.newsletter.currentYear,
    currentWeek: state.newsletter.currentWeek
  }
};

export default connect(mapStateToProps)(NewsletterCreateModalComponent);


// WEBPACK FOOTER //
// ./src/newsletter/newsletterCreateModalComponent.js